import { create } from 'zustand'

const useRunningAudio = create((set) => ({
    audio: null,
    enabled: false,
    setAudio: (audio) => set((state) => ({...state, audio: audio})),
    setEnable: (yesNo) => set((state) => ({...state, enabled: yesNo})),
}))

export default useRunningAudio
